export interface ErrorButtonModel {
  /**
   * id univoco bottone
   */
  id?: string;
  /**
   * testo da visualizzare (sarà trattato come label)
   */
  text: string;
  /**
   * tipo di azione che determina la grafica del pulsante
   */
  action: ErrorAction;
  /**
   * apparenza del pulsante
   */
  appearance?: 'solid' | 'outline';
  /**
   * abilita la chiusura dell'errore
   */
  preventClosing?: boolean;
  /**
   * metodo da eseguire al click
   */
  handler?: () => void;
}

export type ErrorAction = 'retry' | 'stop';
